/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getApiSessionRenew200Schema = z.any();

export const getApiSessionRenewQueryResponseSchema = z.lazy(
  () => getApiSessionRenew200Schema,
);
